import React from "react";
import ContentLoader from "react-content-loader";

const Loader = (props) => (
	<ContentLoader
		speed={2}
		width={400}
		height={460}
		viewBox="0 0 400 460"
		backgroundColor="#f3f3f3"
		foregroundColor="#ecebeb"
		{...props}
	>
		<rect x="29" y="297" rx="2" ry="2" width="152" height="58" />
		<rect x="29" y="225" rx="2" ry="2" width="324" height="58" />
		<rect x="32" y="376" rx="2" ry="2" width="141" height="58" />
		<rect x="197" y="377" rx="2" ry="2" width="155" height="58" />
		<rect x="29" y="154" rx="2" ry="2" width="324" height="58" />
		<rect x="190" y="298" rx="2" ry="2" width="162" height="58" />
		<rect x="28" y="11" rx="2" ry="2" width="324" height="129" />
	</ContentLoader>
);

export default Loader;
